

<div class="module-bar">
	<div class="_inner">
		<button mat-icon-button (click)="dialogRef.close()">
			<mat-icon>{{appService.backIcon}}</mat-icon>
		</button>
		<span class="title flex-grow-1">{{'my_history' | translate}}</span>
	</div>
</div>

<div class="module-content">
	<div class="generic-desc">
		{{'my_history_description' | translate}}
	</div>

	<mat-tab-group>
		<mat-tab label="{{'by_date' | translate}}">
			<div class="sites">
				<div class="generic-list border-top">
					<ng-container *ngFor="let site of sites">
						<ng-container *ngTemplateOutlet="siteTemplate; context: {site:site}"></ng-container>
					</ng-container>
				</div>
			</div>
		</mat-tab>
		<mat-tab label="{{'by_site' | translate}}">
			<div class="border-top">
				<mat-accordion displayMode="flat" class="no-margins generic-list-accordion">
					<mat-expansion-panel *ngFor="let group of groupedSites">
						<mat-expansion-panel-header>
							<mat-panel-title>{{group.name}}</mat-panel-title>
						</mat-expansion-panel-header>

						<div class="generic-list">
							<ng-container *ngFor="let site of group.sites">
								<ng-container *ngTemplateOutlet="siteTemplate; context: {site:site}"></ng-container>
							</ng-container>
						</div>

					</mat-expansion-panel>
				</mat-accordion>
			</div>
		</mat-tab>
	</mat-tab-group>
</div>


<ng-template #siteTemplate let-site="site">
	<div class="generic-list-item" (click)="historyClick(site, $event)">
		<div class="_avatar" [style.background-image]="'url(' + site._o.img +')' | safeStyle"></div>
		<div class="_content">
			<div class="_title"> {{site.name}} </div>
			<div class="_line">
				<span class="inline">{{site.serviceType | translate}}</span>
				<span class="inline px-1">&bull;</span>
				<span class="inline">{{site.date | ldate}}</span>
				<span *ngIf="site.amount || site.amount === 0">
                    <span class="inline px-1">&bull;</span>
                    <span class="inline">{{site.amount | lcurrency}}</span>
                </span>
			</div>
		</div>
	</div>
</ng-template>
